/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BalanceDto } from '../../models/balance-dto';

export interface UserControllerGetBalance$Params {
}

export function userControllerGetBalance(http: HttpClient, rootUrl: string, params?: UserControllerGetBalance$Params, context?: HttpContext): Observable<StrictHttpResponse<BalanceDto>> {
  const rb = new RequestBuilder(rootUrl, userControllerGetBalance.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BalanceDto>;
    })
  );
}

userControllerGetBalance.PATH = '/user/me/balance';
